import styled from 'styled-components';

const PriceChartDiv = styled.div`
  .selectSetsContainer {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    align-items: center;
    justify-content: center;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};

    > *:not(:last-child) {
      margin-right: 20px;
    }
  }

  .pbcRightComponents {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact};
  }

  .selectsContainer {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 50px;
    margin-bottom: 20px;
  }

  .rhcTooltipContainer {
    min-width: 350px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 12px;
    width: 100%;
    margin-bottom: 10px;

    > p {
      color: #abb5be;
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      font-weight: 600;
    }
  }

  .rhcTooltipValues {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: auto;
    width: 75%;

    p {
      margin-left: 5px;
    }
  }

  .rhcTooltipValues > * {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 33%;
    text-align: center;
  }

  .rhcTooltipValues > div:not(:last-child) {
    margin-right: 15px;
  }

  .rhcTooltip {
    padding: 12px;
    min-width: 250px;
  }

  .rhcDate {
    color: #abb5be;
    text-transform: uppercase;
  }

  .rhcLabel {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 50px;
    margin-bottom: 20px;
  }
`;

export default PriceChartDiv;
